class Stopper {
  constructor() {}

  start(tips = '') {
    window.onbeforeunload = function () {
      return tips;
    };
  }

  end() {
    window.onbeforeunload = null;
  }
}

let stopper = new Stopper();

export default stopper;
